import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { FinalCTA } from "@/pages/Home";
import { SERVICES, COMING_SOON_SERVICES, SOLUTIONS } from "@/data/site";

export default function Services() {
  useSEO("Freight Services", "Explore Cargowyn's cross-border trucking, FTL, LTL, flatbed and oversize/heavy-haul freight services between Canada and the US.");
  return (
    <div>
      <section className="bg-[#0B192C] text-white pt-24 pb-20 relative overflow-hidden" data-testid="services-hero">
        <div className="absolute inset-0 noise opacity-[0.05]" />
        <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
          <div className="flex items-center gap-3 mb-5"><span className="h-[2px] w-10 bg-[#FF5A00]" /><span className="font-head uppercase tracking-[0.3em] text-[#FF5A00] text-sm font-700">Our Services</span></div>
          <h1 className="font-head font-black uppercase text-6xl md:text-8xl tracking-tighter leading-[0.85] max-w-4xl">Every mode. One broker.</h1>
          <p className="text-[#94A3B8] text-lg mt-6 max-w-xl">From standard truckload to the oversize loads others turn away — we coordinate it end to end, on both sides of the border.</p>
        </div>
      </section>

      <section className="py-24 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 3) * 0.08}>
                <Link to={`/services/${s.slug}`} data-testid={`services-card-${s.slug}`} className="group block bg-white border-2 border-[#0B192C] h-full hover:-translate-y-2 transition-transform duration-300 hover:hard-shadow-orange">
                  <div className="relative h-48 overflow-hidden border-b-2 border-[#0B192C]">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105" />
                    <div className="absolute top-0 left-0 bg-[#0B192C] p-3"><s.icon size={22} className="text-[#FF5A00]" /></div>
                  </div>
                  <div className="p-7">
                    <div className="flex items-center justify-between"><h3 className="font-head font-800 uppercase text-2xl tracking-tight">{s.title}</h3><ArrowUpRight className="text-[#FF5A00] opacity-0 group-hover:opacity-100 transition-opacity" /></div>
                    <p className="text-[#475569] mt-3 leading-relaxed">{s.short}</p>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>

          <Reveal><h2 className="font-head font-black uppercase text-4xl tracking-tighter mt-20 mb-8">Coming soon</h2></Reveal>
          <div className="grid md:grid-cols-3 gap-6">
            {COMING_SOON_SERVICES.map((c, i) => (
              <Reveal key={c.title} delay={i * 0.08}>
                <div className="bg-[#0B192C] text-white p-8 h-full" data-testid={`coming-soon-${i}`}>
                  <c.icon size={28} className="text-[#94A3B8] mb-4" />
                  <div className="font-head font-800 uppercase text-2xl text-[#CBD5E1]">{c.title}</div>
                  <div className="text-[#64748b] text-sm mt-2">{c.note}</div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal><h2 className="font-head font-black uppercase text-4xl tracking-tighter mt-20 mb-8">Solutions by industry</h2></Reveal>
          <div className="grid md:grid-cols-2 gap-6">
            {SOLUTIONS.map((s, i) => (
              <Reveal key={s.title} delay={(i % 2) * 0.08}>
                <div className="flex items-start gap-6 p-8 border-2 border-[#0B192C]/10 bg-white" data-testid={`services-solution-${i}`}>
                  <div className="font-head font-black text-5xl text-[#FF5A00] leading-none">0{i + 1}</div>
                  <div><h3 className="font-head font-800 uppercase text-2xl tracking-tight">{s.title}</h3><p className="text-[#475569] mt-2">{s.desc}</p></div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
}
